/*
* Adapted from: https://github.com/chanzuckerberg/czi-prosemirror/blob/master/src/ui/ImageInlineEditor.js
*
* MIT License
*
* Copyright (c) 2019 Chan Zuckerberg Initiative
*
* Permission is hereby granted, free of charge, to any person obtaining a copy
* of this software and associated documentation files (the "Software"), to deal
* in the Software without restriction, including without limitation the rights
* to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the Software is
* furnished to do so, subject to the following conditions:
*
* The above copyright notice and this permission notice shall be included in all
* copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
* IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
* AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
* LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
* OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
* SOFTWARE.
*/

// MODULES //

import React from 'react';
import CustomButton from './custom_button.js';
import './inline_editor.css';


// VARIABLES //

const ImageAlignValues = {
	NONE: {
		value: null,
		text: 'Inline'
	},
	LEFT: {
		value: 'left',
		text: 'Float left'
	},
	CENTER: {
		value: 'center',
		text: 'Center'
	},
	RIGHT: {
		value: 'right',
		text: 'Float right'
	}
};


// MAIN //

class ImageInlineEditor extends React.PureComponent {
	_onClick = (align) => {
		this.props.onSelect({
			align: align
		});
	};

	render() {
		const align = this.props.value ? this.props.value.align : null;
		const onClick = this._onClick;
		const buttons = Object.keys( ImageAlignValues ).map(key => {
			const { value, text } = ImageAlignValues[ key ];
			return (
				<CustomButton
					active={align === value}
					key={key}
					label={text}
					onClick={onClick}
					value={value}
				/>
			);
		});
		return <div className="editor-inline-editor">{buttons}</div>;
	}
}


// EXPORTS //

export default ImageInlineEditor;
